import React from 'react';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as CommentIcon } from '../../assets/comment.svg';
import { PromptChip } from './PepWiseAIChatPopup.types';

const PromptChips: React.FC<{ prompts: PromptChip[]; onSelect: (p: string) => void; visible: boolean; title?: string }> = ({ prompts, onSelect, visible, title = 'Suggested follow-ups' }) => {
    const [dismissed, setDismissed] = React.useState(false);
    const chips = prompts;

    // Re-show panel whenever new chips arrive (new response)
    React.useEffect(() => { setDismissed(false); }, [prompts]);

    if (!visible || dismissed || chips.length === 0) return null;

    return (
        <Box sx={{
            mx: 2, mb: 1,
            backgroundColor: '#F0F5FB',
            border: '1px solid #D0DFF0',
            borderRadius: '12px',
            overflow: 'hidden',
        }}>
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, pt: 1, pb: 0.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#003771', opacity: 0.6 }} />
                    <Typography sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '11px', fontWeight: 600, color: '#5B7A9D', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
                        {title}
                    </Typography>
                </Box>
                <Box component="button" onClick={() => setDismissed(true)}
                    sx={{ background: 'none', border: 'none', cursor: 'pointer', p: 0.25, color: '#94A3B8', display: 'flex', alignItems: 'center', '&:hover': { color: '#003771' } }}>
                    <CloseIcon sx={{ fontSize: 13 }} />
                </Box>
            </Box>

            {/* Questions */}
            <Box sx={{ px: 1, pb: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                {chips.map((p) => (
                    <Box key={p.label} component="button" onClick={() => onSelect(p.label)}
                        sx={{
                            display: 'flex', alignItems: 'center', gap: 1,
                            width: '100%', textAlign: 'left',
                            background: 'none', border: 'none', cursor: 'pointer',
                            px: 1, py: 0.75, borderRadius: '8px',
                            transition: 'background-color 0.15s',
                            '&:hover': { backgroundColor: '#003771', '& .chip-text': { color: '#fff' }, '& .chip-icon': { color: '#fff' } },
                        }}>
                        <Box className="chip-icon" sx={{ color: '#003771', opacity: 0.5, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                            <CommentIcon width={12} height={12} />
                        </Box>
                        <Typography className="chip-text" sx={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '13px', fontWeight: 500, color: '#1E3A5F', lineHeight: '18px' }}>
                            {p.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PromptChips;
